export const enClientPortalNotificationSettingsConstantsPages = {
    settings: {
        constants: {
            notifications: {
                groups: {
                    orders: {
                        newMessage: {
                            title: 'New message for an order',
                            description:
                                'You can also be on the notification list of a conversation without being assigned to or ' +
                                'observing the related order.',
                        },
                        newMention: {
                            title: 'New message mentioning you',
                        },
                        newDocument: {
                            title: 'New document in an order',
                        },
                        inspectionDateUpdated: {
                            title: 'Inspection date was updated',
                        },
                        dueDateUpdated: {
                            title: 'Expected completion date was updated',
                        },
                    },
                    orderStatus: {
                        groupTitle: 'Order status',
                        newStatus: {
                            title: 'New order status',
                        },
                        accepted: {
                            title: 'Order was accepted',
                            description: 'This status change is not shown in the daily digest.',
                        },
                        blocked: {
                            title: 'Order is blocked',
                            description: 'This status change is not shown in the daily digest.',
                        },
                    },
                    valuations: {
                        groupTitle: 'Drafts and finalisation',
                        newDraft: {
                            title: 'New appraisal draft was submitted',
                        },
                        finalisedValuation: {
                            title: 'Finalised appraisal was submitted',
                        },
                        finalisedValueCheck: {
                            title: 'Finalised value check was submitted',
                        },
                    },
                    myTasks: {
                        groupTitle: 'Tasks assigned to you',
                        assigned: {
                            title: 'Task was assigned to you',
                        },
                        statusChanged: {
                            title: 'New task status',
                        },
                        newComment: {
                            title: 'New comment on your task',
                        },
                        dueSoon: {
                            title: 'Your task is due soon',
                            description: 'We notify you 14, 7, and 2 days before the task deadline.',
                        },
                        dueTomorrow: {
                            title: 'Your task is due tomorrow',
                        },
                    },
                    otherTasks: {
                        groupTitle: 'Other tasks',
                        created: {
                            title: 'New task was created',
                        },
                        statusChanged: {
                            title: 'New task status',
                        },
                        newComment: {
                            title: 'New comment on a task',
                            description:
                                'You can also be on the notification list of a task conversation without being assigned to or ' +
                                'observing the related order.',
                        },
                    },
                    plausibility: {
                        groupTitle: 'Plausibility check',
                        newMessage: {
                            title: 'New note',
                        },
                        editedMessage: {
                            title: 'Note was edited',
                        },
                        deletedMessage: {
                            title: 'Note was deleted',
                        },
                        shared: {
                            title: 'Notes were shared',
                        },
                        approved: {
                            title: 'Draft approval was granted',
                        },
                        internalApproved: {
                            title: 'Content approval for a draft was granted by the fund partner',
                        },
                    },
                },
            },
        },
    },
}
